import React, { useMemo } from "react";
import { Stepper } from "../../../components/shared/Stepper";
import type { Step } from "../../../components/shared/Stepper";

type AllocationMatrixStepperProps = {
  currentStep: number;
  setCurrentStep: (step: number) => void;
};

export default function AllocationMatrixStepper(
  props: Readonly<AllocationMatrixStepperProps>
) {
  const { currentStep, setCurrentStep } = props;

  const steps = useMemo<Step[]>(
    () => [
      {
        stepNo: 1,
        title: "Factor Selection",
        description: "Select factors",
      },
      {
        stepNo: 2,
        title: "Rule Builder",
        description: "Define rules",
      },
      {
        stepNo: 3,
        title: "Review & Activate",
        description: "Review and finalize",
      },
    ],
    []
  );

  return (
    <Stepper
      steps={steps}
      currentStep={currentStep}
      onStepClick={(step) => {
        if (currentStep > step.stepNo) setCurrentStep(step.stepNo);
      }}
    />
  );
}
